import { render, staticRenderFns } from "./ProfileEditPanel.vue?vue&type=template&id=1b8c2f7b&"
import script from "./ProfileEditPanel.vue?vue&type=script&lang=js&"
export * from "./ProfileEditPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports